module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/18.64f04b41.jpg";